"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getVersion;

var _index = _interopRequireDefault(require("../is/index"));

/**
 * @file 全民小视频 获取全民版本号
 * @author zhangyanting <zhangyanting@baidu.com>
 */

/**
 * 获取全民小视频的版本号
 *
 * @return {string} 全民小视频的版本号
 */
function getVersion() {
  if (!(0, _index.default)()) {
    return '';
  }

  var match = /bdminivideo\/([\d+.]+)/.exec(navigator.userAgent);

  if (match) {
    return match[1];
  } else {
    return '';
  }
}